<template>
  <div id="app">
  </div>
</template>

<script>
import { isMobile } from '@/utils/comUtils'

export default {
  name: 'App',
  mounted () {
    if (isMobile) {
      window.location.replace(window.location.origin + '/h5#/')
    } else {
      window.location.replace(window.location.origin + '/pc#/' + location.search)
    }
  }
}
</script>

<style>
#app {
  font-family: 'PingFangSC-Regular', 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
  margin-top: 60px;
}
</style>



// WEBPACK FOOTER //
// App.vue?d939f864